/**
 * CapacityTile - Tile design for Capacity section
 *
 * Uses BaseTile with full-bleed background image design.
 * Focus: Role/expertise and team building capabilities
 */
import React from 'react';
import BaseTile from './BaseTile';

function CapacityTile({
  resource,
  sectionColor,
  onClick,
  adminMode,
  onRemove,
  onMoveLeft,
  onMoveRight,
  isFirst,
  isLast,
}) {
  return (
    <BaseTile
      resource={resource}
      sectionColor={sectionColor}
      onClick={onClick}
      adminMode={adminMode}
      onRemove={onRemove}
      onMoveLeft={onMoveLeft}
      onMoveRight={onMoveRight}
      isFirst={isFirst}
      isLast={isLast}
    />
  );
}

export default CapacityTile;
